<template>
  <div :class="$b()">
    <div :class="$b('container')">
      <div
        v-if="$slots.heading"
        :class="$b('meta')"
      >
        <h4
          :class="$b('heading')"
        >
          <slot name="heading" />
        </h4>
        <span v-if="$slots.button">
          <slot name="button" />
        </span>
      </div>
      <div :class="$b('swatches')">
        <SwatchSelect
          v-bind="{ ...$props, ...$attrs }"
          :show-limited-edition-badge="showLimitedEditionBadge"
          :limited-edition-count="limitedEditionCount"
          @active-swatch-index-changed="
            (val) => $emit('active-swatch-index-changed', val)
          "
        >
          <slot name="swatchButton" />
        </SwatchSelect>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelledSwatchSelect',
  props: {
    variants: {
      type: Array,
      required: true,
    },

    scaleUp: {
      type: Boolean,
      default: false,
    },

    showLimitedEditionBadge: {
      type: Boolean,
      default: false,
    },

    activeSwatchIndex: {
      type: Number,
      default: 0,
    },
    limitedEditionCount: {
      type: Number,
      default: 0,
    }
  },
  emits: [
    'active-swatch-index-changed'
  ]
}
</script>

<style lang="postcss">
.LabelledSwatchSelect__container {
  @screen md {
    @apply pt-8;
  }
}

/** Lens Tech Tabs - Preview  */
.ProductDetailPage--lens-tech-tabs {
  .LabelledSwatchSelect__container {
    @screen md {
      @apply pt-8;
    }
  }
}

.LabelledSwatchSelect__heading {
  @apply text-sm font-bold inline-block;
}

.LabelledSwatchSelect__meta {
  @apply flex justify-between items-center mb-3 px-1;

  .VisionLink__text {
    @apply text-xxs;
  }
}

.LabelledSwatchSelect__heading-suffix {
  @apply font-light;
}
</style>
